import React from "react";
import AdminCrud from "@/components/AdminCrud";

export default function AdminAuthors() {
  return (
    <AdminCrud
      title="Autores"
      resource="authors"
      initialItem={{ status: "published" }}
      fields={[
        { name: "name", label: "Nome", required: true },
        { name: "slug", label: "Slug (URL)", required: true, help: "Ex: helena-vasconcelos" },
        { name: "photo_url", label: "Foto do autor", type: "image" },
        { name: "biography", label: "Biografia", textarea: true, rows: 5 },
        { name: "instagram", label: "Instagram (URL)" },
        { name: "facebook", label: "Facebook (URL)" },
        { name: "twitter", label: "Twitter/X (URL)" },
        { name: "website", label: "Site pessoal" },
        { name: "video_url", label: "URL de vídeo (YouTube)" },
        { name: "featured", label: "Destaque", type: "checkbox" },
      ]}
      columns={[
        { name: "name", label: "Nome" },
        { name: "slug", label: "Slug" },
        { name: "featured", label: "Destaque", render: (r) => r.featured ? "Sim" : "Não" },
      ]}
    />
  );
}
